import * as tslib_1 from "tslib";
/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import * as React from "react";
import PropTypes from "prop-types";
import { useTheme } from "./Theme/Providers";
var getStyles = function (theme) { return ({
    fixed: css({
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        zIndex: theme.zIndices.fixed
    }),
    static: css({
        position: "static",
        boxShadow: "none"
    }),
    absolute: css({
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%"
    }),
    sticky: css({
        position: "sticky",
        top: 0,
        zIndex: theme.zIndices.sticky
    })
}); };
/**
 * A Navbar is used to provide app based navigation. Typically
 * used in combination with a Toolbar.
 */
export var Navbar = function (_a) {
    var _b = _a.position, position = _b === void 0 ? "fixed" : _b, children = _a.children, other = tslib_1.__rest(_a, ["position", "children"]);
    var theme = useTheme();
    var styles = React.useMemo(function () { return getStyles(theme); }, [theme]);
    return (jsx("nav", tslib_1.__assign({ css: [
            {
                background: theme.colors.background.default,
                zIndex: position === "fixed" ? theme.zIndices.fixed : undefined,
                boxShadow: theme.shadows.sm
            },
            styles[position]
        ] }, other), children));
};
Navbar.propTypes = {
    position: PropTypes.oneOf(["fixed", "static"]),
    children: PropTypes.node
};
